import styled from 'styled-components';
import ShareIcon from 'js/components/core/Icons/ShareIcon';

export default styled(ShareIcon)`
  height: 1rem;
  width: 1rem;
  margin: 0 1rem;
`;
